// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import editorHtml from './components/ETC/editor/content'

import '@/assets/css/han.css'
import '@/assets/css/ryu.css'

Vue.config.productionTip = false
// 모든 DB 본문 뷰어에 같은 HTML 정제/표시 규칙을 적용한다.
Vue.directive('editor-html', editorHtml)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  store,
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js